function countryModalShow()
{
  if (localStorage.getItem('p1-country-modal-au') == '1')
  {
    return false;
  }
  $('#p1-country-overlay').show();
  $('.p1-country-modal').css("display", "flex").hide().fadeIn();
  $('body').addClass('p1-country-noscroll');
}
function countryModalClose()
{
  $('body').removeClass('p1-country-noscroll');
  $('#p1-country-overlay').fadeOut();
  $('.p1-country-modal').fadeOut();
  localStorage.setItem('p1-country-modal-au', '1');
  return false;
}

// Only execute when p1-country-modal-au is not set to reduce api calls
(function(g,e,o,t,a,r,ge,tl,y){
if (localStorage.getItem('p1-country-modal-au') != '1')
{  
  t=g.getElementsByTagName(e)[0];y=g.createElement(e);y.async=true;
  y.src='https://g1386590346.co/gl?id=-N5gL3pkazRkNtVdKrEo&refurl='+g.referrer+'&winurl='+encodeURIComponent(window.location);
  t.parentNode.insertBefore(y,t);
}})(document,'script');

if (typeof geotargetly_loaded === 'function') {
  geotargetly_loaded();
}

function geotargetly_loaded(){
  if (typeof geotargetly_country_code !== 'function') {
    return false;
  }
  var p1_country_code = geotargetly_country_code();
  if (p1_country_code != 'AU'
      && p1_country_code != 'CC'
      && p1_country_code != 'CX'
      && p1_country_code != 'CK'
      && p1_country_code != 'HK'
      && p1_country_code != 'ID'
      && p1_country_code != 'JP'
      && p1_country_code != 'FJ'
      && p1_country_code != 'NF'
      && p1_country_code != 'NZ'
      && p1_country_code != 'SG'
      && p1_country_code != 'ZA'
     )
  {  
    const script = document.createElement("script");
    script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.6.1/jquery.min.js';
    script.type = 'text/javascript';
    script.addEventListener('load', () => {
      if (typeof countryModalShow === 'function') {
        countryModalShow();
      }
    });
    document.head.appendChild(script);
  }
  else
  {
    localStorage.setItem('p1-country-modal-au', '1');
  }
}